<div id="vtz-main-wrapper" class="vtz-main-wrapper">
  <div id="vtz-main-container" class="vtz-main-container vtz-main-container--ballot">
    <div id="vtz-title-section" class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>
    <br><br>
    <h1 id="vtz-title-section-text" class="vtz-h1" i18n>
      You have successfully registered.
    </h1>
    @if (votingPin === undefined) {
      <div>
        <h2 id="vtz-success-code-text" class="vtz-text vtz-text--wide vtz-text--center" i18n>
          You should have received an email or text message with the Voting Pin and the URL of the voting site. Please note you will no longer need the information on your voter letter. To vote you will only need the Voter Pin and authorized email going forward.
        </h2>
      </div>
    }
    @if (votingPin !== undefined) {
      <div id="vtz-success-code-wrapper" class="vtz-success-code__wrapper">
        <h2 id="vtz-success-code-text" class="vtz-text vtz-text--wide vtz-text--center" i18n>
          The following is your Voting PIN.
        </h2>
        <p id="vtz-success-code-text-2" class="vtz-text vtz-text--wide vtz-text--center" i18n="Explanation of the user's voting PIN">
          <strong>Write this number down.</strong> You will need to enter it when you vote. The registration PIN in your Voter Information Letter cannot be used to vote.
        </p>
        <div id="vtz-success-code-container" class="vtz-success-code__container">
          <span id="voting_pin" class="vtz-success-code__text">
            {{votingPin}}
          </span>
        </div>
        <h2 id="vtz-success-code-subtext3" class="vtz-text vtz-text--wide vtz-text--center vtz-text--extra-space" i18n>
          Thank you for using the Voatz Web App!
        </h2>
      </div>
    }
    @if(aboutService.electionNotYetOpen){
      <h1 id="main-title" class="vtz-h1" i18n>Note: Election not open yet</h1>
      <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
        The election will be open from {{aboutService.startTime}} until {{this.aboutService.endTime}}. You will be able to sign into the voting app then. Click "PROCEED" to return to the welcome screen.
      </p>
    }
    <div id="vtz-actions" class="vtz-actions">
      <div id="vtz-button-group" class="button-group button-group--sucess">
        <button id="submit-button" autofocus 
                class="button-primary" 
                i18n="Button label" 
                (click)="exit()"
                [attr.aria-describedby]="votingPin === undefined 
                  ? 'vtz-title-section-text vtz-success-code-text' 
                  : 'vtz-title-section-text vtz-success-code-text vtz-success-code-text-2'">
          PROCEED
        </button>
      </div>
    </div>
  </div>
</div>
<app-back-button-confirmation-modal>
</app-back-button-confirmation-modal>